import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

const Label = styled.label`
    cursor: pointer;
`;

const Input = styled.input`
    display: none;
`;


export type TProps = {
    radiogroup: string;
    value: string;
    onSelect: () => void;
    isSelected: boolean;
    children: ReactNode;
}

const ContentSelect: FC<TProps> = ({radiogroup, value, onSelect, isSelected, children}) => {
    return (
        <Label className={`${(isSelected)
            ? 'selected cr-bg-secondary cr-text-white'
            : 'cr-bg-white'
        } cr-p-lg cr-shadow cr-flex cr-rounded-block`
        }>
            <Input type="radio" name={radiogroup} value={value} onChange={onSelect}/>
            {children}
        </Label>
    );
};

export default ContentSelect;